export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/b552ae94a3baa9664c4076d726380c66.svg";